import React from 'react';
import CustomPage from 'src/components/CustomPage';

const Terms: React.FC = () => {
  return <CustomPage pageType="tos" pageName="Terms" />;
};

export default Terms;
